import { setObjectFromApp } from './config'
import { Routes } from './types'

const contentApps = setObjectFromApp(Array.from(document.querySelectorAll('.single-spa-app')));

export const setActiveContentLayout = () => {
  const status = 'active';
  const clearLayout = () => {
    Object.values(contentApps).forEach((app: HTMLElement) => {
      app.toggleAttribute(status, false);
    });
  }

  window.addEventListener('single-spa:before-routing-event', ({ detail }: any) => {
    clearLayout();
    const activeBaseRoute = new URL(detail.newUrl).pathname.split('/')[1]
    switch (activeBaseRoute) {
      case (Routes.DASHBOARD): {
        contentApps.intbDashboardApp.toggleAttribute(status, true);
        contentApps.tbcfDashboardApp.toggleAttribute(status, true);
        break;
      }
      case (Routes.INTB): {
        contentApps.intbDashboardApp.toggleAttribute(status, true);
        contentApps.intbApp.toggleAttribute(status, true);
        break;
      }
      case (Routes.TBCF): {
        contentApps.tbcfDashboardApp.toggleAttribute(status, true);
        contentApps.tbcfApp.toggleAttribute(status, true);
        break;
      }
      case (Routes.ALC): {
        contentApps.alcApp.toggleAttribute(status, true);
        break;
      }
      case (Routes.CONTROL): {
        contentApps.controlApp.toggleAttribute(status, true);
        break;
      }
    }
  });
}

//Dynamic set active based on mounted app - slower

// import { getMountedApps } from "single-spa";
  // window.addEventListener('single-spa:routing-event', () => {
  //   const actived = getMountedApps()
  //   console.log(actived)

  //   const removeWhenNoActive = () => {
  //     singleSpaAppContent.forEach(app => {
  //       app.toggleAttribute('active', false);
  //     });
  //   }
  //   const addWhenActive = (data) => {
  //     data.forEach(app => {
  //       const activeApp = singleSpaAppContent.find(el => el.id === `single-spa-application:${app}`)
  //       activeApp && activeApp.toggleAttribute('active', true);
  //     })
  //   }

  //   removeWhenNoActive();
  //   addWhenActive(actived);
  // });